/* @flow */
import React from 'react';
import Glyph from 'components/Glyph.jsx';

import './styles/BankAccountSelectorItem.scss';

export const BankAccountSelectorItem = (props: Object) => {
  return (
    <div className="BankAccountSelectorItem">
      {props.children}
    </div>
  );
};

export const BankAccountSelectorAddItem = () => {
  return (
    <BankAccountSelectorItem>
      <div className="BankAccountSelectorItem BankAccountSelectorItem-add">
        <Glyph color="brand" name="plus-circle-fill" size="large" />
        Add another bank account
      </div>
    </BankAccountSelectorItem>
  );
};



// WEBPACK FOOTER //
// ./src/payments/components/BankAccountSelectorItem.jsx